module.exports = __webpack_public_path__ + "img/fraud-7.68be07c9.jpg";